import { isAfter } from 'date-fns';
import { Products } from 'enums';
import _ from 'lodash';

export const isProductHidden = (userProducts: Products[], checkProducts: Products[], createdAt: string | undefined) => {
  if (!createdAt) return false;
  // july 16th 2024
  const hideProductDate = new Date(2024, 6, 16);
  const accountCreationDate = new Date(createdAt);
  const commonProducts = _.intersection(userProducts, checkProducts);

  return isAfter(accountCreationDate, hideProductDate) && commonProducts.length === 0;
};
